import { useEffect, useState } from 'react';
import { loadFonts, loadCriticalFonts } from '../utils/fontOptimizer';

export const useFontLoading = () => {
    const [fontsLoaded, setFontsLoaded] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadAllFonts = async () => {
            try {
                // Load critical fonts first
                await loadCriticalFonts();

                // Then load all fonts
                await loadFonts();

                setFontsLoaded(true);
            } catch (error) {
                console.warn('Font loading failed:', error);
                // Continue even if fonts fail to load
                setFontsLoaded(true);
            } finally {
                setLoading(false);
            }
        };

        loadAllFonts();
    }, []);

    return { fontsLoaded, loading };
}; 